import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import React from "react";
import Btn from "@/components/common/Btn";
import { useStore } from "@/store/index";
import { EBtnType } from "@/models/common/enums";
import { shallow } from "zustand/shallow";
import {
    chekStartOrEndWithSpace,
    isValidEmail,
    isValidPhoneNumber,
    isValidWithoutSpace,
} from "@/utils/common";

const ButtonSection = () => {
    const dispatch = useStore(state => state.dispatchUser);
    const updateUserDetail = useStore(state => state.updateUserDetail);
    const {
        name,
        surname,
        email,
        birthdate,
        gender,
        cityOfBirth,
        taxIdCode,
        address,
        languagesPreference,
        phone,
        city,
        country,
        zipCode,
    } = useStore(
        state => ({
            name: state.userState.userDetail.name,
            surname: state.userState.userDetail.surname,
            email: state.userState.userDetail.email,
            birthdate: state.userState.userDetail.birthDate,
            gender: state.userState.userDetail.gender,
            cityOfBirth: state.userState.userDetail.cityOfBirth,
            taxIdCode: state.userState.userDetail.taxIdCode,
            address: state.userState.userDetail.address,
            languagesPreference: state.userState.userDetail.language,
            phone: state.userState.userDetail.phone,
            city: state.userState.userDetail.city,
            country: state.userState.userDetail.country,
            county: state.userState.userDetail.county,
            zipCode: state.userState.userDetail.zipCode,
        }),
        shallow
    );

    const clearAll = () => {
        dispatch({
            type: "UPDATE_USER_DETAIL",
            payload: {
                birthDate: "",
                /* "Mon Oct 01 1900 00:00:00 GMT+0100 (Ora legale dell’Europa centrale)", */
                gender: "",
                cityOfBirth: "",
                taxIdCode: "",
                address: "",
                language: "",
                usernameInstagram: "",
                usernameTwitter: "",
                usernameFacebook: "",
                bio: "",
                displayName: "",
                phone: "",
                name: "",
                surname: "",
                county: "",
                city: "",
                country: "",
                zipCode: "",
            },
        });
    };

    const checkBtn =
        chekStartOrEndWithSpace(name) &&
        chekStartOrEndWithSpace(surname) &&
        isValidEmail(email) &&
        birthdate &&
        gender &&
        chekStartOrEndWithSpace(cityOfBirth) &&
        chekStartOrEndWithSpace(city) &&
        // chekStartOrEndWithSpace(county) &&
        chekStartOrEndWithSpace(country) &&
        chekStartOrEndWithSpace(zipCode) &&
        isValidWithoutSpace(taxIdCode) &&
        chekStartOrEndWithSpace(address) &&
        languagesPreference?.trim() &&
        (!phone || isValidPhoneNumber(phone));

    return (
        <div className="mt-5">
            <MDBRow>
                <MDBCol size={12} xl={3} className="my-3">
                    <Btn
                        onClick={() => updateUserDetail()}
                        disabled={!checkBtn}
                    >
                        Update profile
                    </Btn>
                </MDBCol>
                <MDBCol size={12} xl={3} className="my-3">
                    <Btn
                        btnType={EBtnType.TRANSPARENT}
                        className="border-0 PIfontSemiBold"
                        onClick={clearAll}
                    >
                        X Clear it all
                    </Btn>
                </MDBCol>
            </MDBRow>
        </div>
    );
};

export default ButtonSection;
